var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1145_20927)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 9.58325,
    height: 12.7777,
    rx: 1.83998,
    stroke: "#747474",
    strokeWidth: 1.37999,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 17.6113,
    width: 9.58325,
    height: 6.38883,
    rx: 1.83998,
    stroke: "#747474",
    strokeWidth: 1.37999,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.416,
    y: 1,
    width: 9.58325,
    height: 6.38883,
    rx: 1.83998,
    stroke: "#747474",
    strokeWidth: 1.37999,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.416,
    y: 11.2227,
    width: 9.58325,
    height: 12.7777,
    rx: 1.83998,
    stroke: "#747474",
    strokeWidth: 1.37999,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1145_20927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.0197c1a11f8b8c4e24105df00afe4529.svg";
export { ForwardRef as ReactComponent };